export default __webpack_public_path__ + "static/media/charm-s8.9c1901b0.png";